import "./dashboard.css";
import { useCallback, useEffect, useRef, useState } from "react";
import moment from "moment";
// import { Icon } from "../../../shared/icons/icon";
import { AnalyticsChart } from "./analytics-chart";
import { SHARED_SERVICES } from "../../../core/services/shared-services";
import { HELPER } from "../../../shared/helper/helper";
import { FormDropdown } from "../../../shared/components/form-component/form-dropdown";
import { FormInput } from "../../../shared/components/form-component/form-input";
import { CustomBreadcrumb } from "../custom-breadcrumb/custom-breadcrumb";
import { Skeleton } from "primereact/skeleton";
import { Toast } from "primereact/toast";
import { Icon } from "../../icons/icon";
import { MetricsSummaryCards } from "./metrics-summary-cards";
import { Optional } from "../optional/optional";
// import { DashboardFilter } from "./dashboard-filter";

export function Dashboard(props) {
  const toast = useRef(null);
  const [selectedMetricType, setSelectedMetricType] = useState("transactions");
  const [dateRangeValue, setDateRangeValue] = useState("today");
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentDayMetrics, setCurrentDayMetrics] = useState(null);
  const [historicMetrics, setHistoricMetrics] = useState(null);
  const [disputeMetricsBreakdown, setDisputeMetricsBreakdown] = useState(null);
  const [loading, setLoading] = useState(true);
  const [overallMetrics, setOverallMetrics] = useState(null);
  const [currentTime, setCurrentTime] = useState(moment().format("HH:mm"));
  const [noData, setNoData] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const reloadFunctionDetails = useRef({
    reloadFunction: null,
    params: null,
  });

  // Filter
  const selectedReport = useRef({
    desc: "Transactions",
    code: "transactions",
  });
  const selectedDateRange = useRef({
    desc: "Today",
    code: "today",
  });
  const dataOptions = [
    { desc: "Transactions", code: "transactions" },
    { desc: "Disputes", code: "disputes" },
  ];
  const dateRanges = [
    { desc: "Today", code: "today" },
    { desc: "Yesterday", code: "1" },
    { desc: "Last 7 days", code: "7" },
    { desc: "Last 14 days", code: "14" },
    { desc: "Custom", code: "custom" },
  ];
  const [showCustomDateField, setShowCustomDateField] = useState(false);
  const [dateFilterError, setDateFilterError] = useState(false);
  const dateFilter = useRef({
    startDate: moment().format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
  });
  const [customDate, setCustomDate] = useState({
    startDate: moment().subtract(1, "days").format("YYYY-MM-DD"),
    endDate: moment().subtract(1, "days").format("YYYY-MM-DD"),
  });
  // Filter

  const getCurrentDayTransactionAnalytics = useCallback(() => {
    reloadFunctionDetails.current = {
      reloadFunction: getCurrentDayTransactionAnalytics,
      params: null,
    };
    setLoading(true);
    SHARED_SERVICES.GET_CURRENT_DAY_TRANSACTION_ANALYTICS(props.userType)
      .then((data) => {
        let result = data?.result;
        setCurrentDayMetrics(result);
        let overallMetrics =
          props.userType === "front-office" ? result : result.overallMetrics;
        setOverallMetrics({
          totalCount: overallMetrics?.totalCount,
          totalAmount: overallMetrics?.totalAmount,
          successfulCount: overallMetrics?.successfulCount,
          successfulAmount: overallMetrics?.successfulAmount,
          failedCount: overallMetrics?.failedCount,
          failedAmount: overallMetrics?.failedAmount,
        });
        if (overallMetrics?.totalCount === 0) {
          handleNoAnalyticsData("No data found!");
        } else {
          setNoData(false);
          setErrorMessage(null);
        }
        setCurrentTime(moment().format("HH:mm"));
        setLoading(false);
      })
      .catch((error) => {
        // console.log("error", error);
        // console.log(HELPER.PROCESS_ERROR(error));
        setNoData(true);
        setErrorMessage(HELPER.PROCESS_ERROR(error, "TOAST"));
        toast.current.show({
          severity: "error",
          summary: "Error!",
          detail: HELPER.PROCESS_ERROR(error, "TOAST"),
          life: 5000,
        });
        setLoading(false);
        resetOverallMetrics();
      });
  }, [props.userType]);

  const getCurrentDayDisputeAnalytics = useCallback(() => {
    reloadFunctionDetails.current = {
      reloadFunction: getCurrentDayDisputeAnalytics,
      params: null,
    };
    setLoading(true);
    SHARED_SERVICES.GET_CURRENT_DAY_DISPUTE_ANALYTICS(props.userType)
      .then((data) => {
        let result = data?.result;
        const overallMetrics =
          props.userType === "front-office" ? result : result?.overallMetrics;
        const totalCount =
          overallMetrics?.backofficeLoggedCount +
          overallMetrics?.merchantLoggedCount;
        setOverallMetrics({
          totalCount: totalCount,
          totalAmount:
            overallMetrics?.backofficeLoggedValue +
            overallMetrics?.merchantLoggedValue,
          successfulCount:
            overallMetrics?.backofficeAcceptedCount +
            overallMetrics?.merchantAcceptedCount,
          successfulAmount:
            overallMetrics?.backofficeAcceptedValue +
            overallMetrics?.merchantAcceptedValue,
          failedCount:
            overallMetrics?.backofficeRejectedCount +
            overallMetrics?.merchantRejectedCount,
          failedAmount:
            overallMetrics?.backofficeRejectedValue +
            overallMetrics?.merchantRejectedValue,
        });
        if (props.userType === "front-office") {
          setDisputeMetricsBreakdown({
            backofficeTotalCount: overallMetrics?.backofficeLoggedCount,
            agentTotalCount: overallMetrics?.merchantLoggedCount,
            backofficeTotalValue: overallMetrics?.backofficeLoggedValue,
            agentTotalValue: overallMetrics?.merchantLoggedValue,
            backofficeAcceptedCount: overallMetrics?.backofficeAcceptedCount,
            agentAcceptedCount: overallMetrics?.merchantAcceptedCount,
            backofficeAcceptedValue: overallMetrics?.backofficeAcceptedValue,
            agentAcceptedValue: overallMetrics?.merchantAcceptedValue,
            backofficeRejectedCount: overallMetrics?.backofficeRejectedCount,
            agentRejectedCount: overallMetrics?.merchantRejectedCount,
            backofficeRejectedValue: overallMetrics?.backofficeRejectedValue,
            agentRejectedValue: overallMetrics?.merchantRejectedValue,
          });
        }
        if (totalCount === 0) {
          handleNoAnalyticsData("No data found!");
        } else {
          setNoData(false);
          setErrorMessage(null);
        }
        setCurrentDayMetrics(result);
        setCurrentTime(moment().format("HH:mm"));
        setLoading(false);
      })
      .catch((error) => {
        setNoData(true);
        setErrorMessage(HELPER.PROCESS_ERROR(error, "TOAST"));
        setLoading(false);
        toast.current.show({
          severity: "error",
          summary: "Error!",
          detail: HELPER.PROCESS_ERROR(error, "TOAST"),
          life: 5000,
        });
        resetOverallMetrics();
      });
  }, [props.userType]);

  const getHistoricTransactionAnalytics = useCallback(
    (date) => {
      reloadFunctionDetails.current = {
        reloadFunction: getHistoricTransactionAnalytics,
        params: date,
      };
      setLoading(true);
      setDateFilterError(false);
      const params = HELPER.TO_URL_STRING(date);
      SHARED_SERVICES.GET_HISTORIC_TRANSACTION_ANALYTICS(params, props.userType)
        .then((data) => {
          const result = data?.result;
          const overallMetrics = result?.generalAnalyticsSummary;
          const totalCount =
            overallMetrics?.totalSuccessfulTransactionCount +
            overallMetrics?.totalFailedTransactionCount;
          setOverallMetrics({
            totalCount: totalCount,
            totalAmount:
              overallMetrics?.totalSuccessfulTransactionValue +
              overallMetrics?.totalFailedTransactionValue,
            successfulCount: overallMetrics?.totalSuccessfulTransactionCount,
            successfulAmount: overallMetrics?.totalSuccessfulTransactionValue,
            failedCount: overallMetrics?.totalFailedTransactionCount,
            failedAmount: overallMetrics?.totalFailedTransactionValue,
          });
          if (totalCount === 0) {
            handleNoAnalyticsData("No data found!");
          } else {
            setNoData(false);
            setErrorMessage(null);
          }
          // console.log("yoooo", selectedDateRange?.code);
          setDateRangeValue(selectedDateRange?.current?.code);
          setHistoricMetrics(result);
          setLoading(false);
        })
        .catch((error) => {
          setNoData(true);
          setErrorMessage(HELPER.PROCESS_ERROR(error, "TOAST"));
          setLoading(false);
          toast.current.show({
            severity: "error",
            summary: "Error!",
            detail: HELPER.PROCESS_ERROR(error, "TOAST"),
            life: 5000,
          });
          resetOverallMetrics();
        });
    },
    [props.userType]
  );

  const getHistoricDisputeAnalytics = useCallback(
    (date) => {
      reloadFunctionDetails.current = {
        reloadFunction: getHistoricDisputeAnalytics,
        params: date,
      };
      setLoading(true);
      setDateFilterError(false);
      const params = HELPER.TO_URL_STRING(date);
      SHARED_SERVICES.GET_HISTORIC_DISPUTE_ANALYTICS(params, props.userType)
        .then((data) => {
          const result = data?.result;
          const overallMetrics = result?.generalSummary;
          const totalCount =
            overallMetrics?.backofficeLoggedCount +
            overallMetrics?.merchantLoggedCount;
          setOverallMetrics({
            totalCount: totalCount,
            totalAmount:
              overallMetrics?.backofficeLoggedValue +
              overallMetrics?.merchantLoggedValue,
            successfulCount:
              overallMetrics?.backofficeAcceptedCount +
              overallMetrics?.merchantAcceptedCount,
            successfulAmount:
              overallMetrics?.backofficeAcceptedValue +
              overallMetrics?.merchantAcceptedValue,
            failedCount:
              overallMetrics?.backofficeRejectedCount +
              overallMetrics?.merchantRejectedCount,
            failedAmount:
              overallMetrics?.backofficeRejectedValue +
              overallMetrics?.merchantRejectedValue,
          });
          if (props.userType === "front-office") {
            setDisputeMetricsBreakdown({
              backofficeTotalCount: overallMetrics?.backofficeLoggedCount,
              agentTotalCount: overallMetrics?.merchantLoggedCount,
              backofficeTotalValue: overallMetrics?.backofficeLoggedValue,
              agentTotalValue: overallMetrics?.merchantLoggedValue,
              backofficeAcceptedCount: overallMetrics?.backofficeAcceptedCount,
              agentAcceptedCount: overallMetrics?.merchantAcceptedCount,
              backofficeAcceptedValue: overallMetrics?.backofficeAcceptedValue,
              agentAcceptedValue: overallMetrics?.merchantAcceptedValue,
              backofficeRejectedCount: overallMetrics?.backofficeRejectedCount,
              agentRejectedCount: overallMetrics?.merchantRejectedCount,
              backofficeRejectedValue: overallMetrics?.backofficeRejectedValue,
              agentRejectedValue: overallMetrics?.merchantRejectedValue,
            });
          }
          if (totalCount === 0) {
            handleNoAnalyticsData("No data found!");
          } else {
            setNoData(false);
            setErrorMessage(null);
          }
          // setDateRangeValue(selectedDateRange?.current?.code);
          setHistoricMetrics(result);
          setLoading(false);
        })
        .catch((error) => {
          setNoData(true);
          setErrorMessage(HELPER.PROCESS_ERROR(error, "TOAST"));
          setLoading(false);
          toast.current.show({
            severity: "error",
            summary: "Error!",
            detail: HELPER.PROCESS_ERROR(error, "TOAST"),
            life: 5000,
          });
          resetOverallMetrics();
        });
    },
    [props.userType]
  );

  function handleNoAnalyticsData(message) {
    setNoData(true);
    setErrorMessage(message);
    toast.current.show({
      severity: "success",
      summary: "No data!",
      detail: message,
      life: 5000,
    });
  }

  function resetOverallMetrics() {
    setOverallMetrics({
      totalCount: 0,
      totalAmount: 0,
      successfulCount: 0,
      successfulAmount: 0,
      failedCount: 0,
      failedAmount: 0,
    });
  }

  // Filter
  function handleReportTypeSelection(e) {
    selectedReport.current = e?.value;
    setSelectedMetricType(e?.value?.code);
    if (dateRangeValue === "today") {
      if (selectedReport?.current?.code === "transactions") {
        getCurrentDayTransactionAnalytics();
      } else {
        getCurrentDayDisputeAnalytics();
      }
    } else {
      if (selectedReport?.current?.code === "transactions") {
        getHistoricTransactionAnalytics(dateFilter.current);
      } else {
        getHistoricDisputeAnalytics(dateFilter.current);
      }
    }
    e?.value?.code === "disputes" ? setCurrentIndex(1) : setCurrentIndex(0);
  }

  function handleDateRangeSelection(e) {
    setDateFilterError(false);
    const selectedDate = e?.value;
    selectedDateRange.current = selectedDate;
    setShowCustomDateField(false);
    if (selectedDate?.code === "custom") {
      dateFilter.current = {
        startDate: moment().subtract(1, "days").format("YYYY-MM-DD"),
        endDate: moment().subtract(1, "days").format("YYYY-MM-DD"),
      };
      setShowCustomDateField(true);
      return;
    } else if (selectedDate.code === "today") {
      if (selectedReport?.current?.code === "transactions") {
        getCurrentDayTransactionAnalytics();
      } else {
        getCurrentDayDisputeAnalytics();
      }
    } else if (selectedDate.code !== "custom") {
      let startAndEndDate = {
        startDate: moment()
          .subtract(Number(selectedDate.code), "days")
          .format("YYYY-MM-DD"),
        endDate: moment().subtract(1, "days").format("YYYY-MM-DD"),
      };
      dateFilter.current = startAndEndDate;
      if (selectedReport?.current?.code === "transactions") {
        getHistoricTransactionAnalytics(startAndEndDate);
      } else {
        getHistoricDisputeAnalytics(startAndEndDate);
      }
    }
    setDateRangeValue(selectedDate?.code);
  }

  function validateDateSelection(e, field) {
    const dateValue = e?.target?.value;
    setCustomDate({
      ...customDate,
      [field]: dateValue,
    });
    dateFilter.current = {
      ...dateFilter.current,
      [field]: dateValue,
    };
  }

  function handleCustomDateSearch() {
    const customDate = dateFilter?.current;
    if (customDate?.startDate && customDate?.endDate) {
      const dateDifference = HELPER.GET_DATE_DIFFERENCE(
        dateFilter?.current?.startDate,
        dateFilter?.current?.endDate
      );
      if (dateDifference > 14 || dateDifference < 0) {
        setDateFilterError(true);
      } else {
        if (selectedReport?.current?.code === "transactions") {
          getHistoricTransactionAnalytics(dateFilter.current);
        } else {
          getHistoricDisputeAnalytics(dateFilter.current);
        }
      }
    } else {
      setDateFilterError(true);
    }
  }

  //Filter

  useEffect(() => {
    getCurrentDayTransactionAnalytics();
    // getHistoricTransactionAnalytics();
  }, [getCurrentDayTransactionAnalytics]);

  function reload() {
    const params = reloadFunctionDetails?.current?.params;
    reloadFunctionDetails?.current?.reloadFunction(params);
  }

  const currentChartView = () => {
    if (noData) {
      return (
        <div className="card p-mt-5 empty" style={{ textAlign: "center" }}>
          <Icon icon="not-found" />
          <p style={{ fontSize: "0.8rem" }}>{errorMessage}</p>
          <div>
            <button className="primary-button" onClick={reload}>
              Reload
            </button>
          </div>
        </div>
      );
    } else {
      return (
        <AnalyticsChart
          userType={props.userType}
          dateRange={dateRangeValue}
          metricType={selectedMetricType}
          currentDayMetrics={currentDayMetrics}
          historicMetrics={historicMetrics}
        />
      );
    }
  };

  return (
    <div>
      <div>
        <Toast ref={toast} />
      </div>
      <div className="page-title p-text-left">Dashboard</div>
      <div className="p-mt-2">
        <CustomBreadcrumb page="Dashboard" />
      </div>
      <div className="p-grid p-mt-3">
        <div className="p-col-4 dropdown-wrapper">
          <FormDropdown
            required={true}
            label="desc"
            value={selectedReport.current}
            fn={handleReportTypeSelection}
            options={dataOptions}
            placeholder="Select analytics type"
          />
        </div>
        <div className="p-col-4 dropdown-wrapper">
          <FormDropdown
            required={true}
            label="desc"
            value={selectedDateRange.current}
            fn={handleDateRangeSelection}
            options={dateRanges}
            placeholder="Select time"
          />
        </div>
        <div className="p-col-4 date-select-row">
          <Optional show={showCustomDateField}>
            <div>
              <div className="p-grid">
                <div className="p-col-6 p-pt-0">
                  <FormInput
                    inputType="date"
                    value={customDate["startDate"]}
                    required={false}
                    field="startDate"
                    type="INPUT"
                    error={dateFilterError}
                    fn={validateDateSelection}
                    loading={false}
                    max={moment().subtract(1, "days").format("YYYY-MM-DD")}
                    placeholder="Start date"
                  />
                </div>
                <div className="p-col-6 p-pt-0">
                  <FormInput
                    inputType="date"
                    value={customDate["endDate"]}
                    required={false}
                    field="endDate"
                    type="INPUT"
                    error={dateFilterError}
                    fn={validateDateSelection}
                    max={moment().subtract(1, "days").format("YYYY-MM-DD")}
                    loading={false}
                    placeholder="End date"
                  />
                </div>
              </div>
            </div>
          </Optional>
          <Optional show={dateFilterError}>
            <p
              className="p-text-error p-mt-0"
              style={{
                color: "red",
                textAlign: "left",
                fontSize: "0.75rem",
                transform: "translateY(-15px)",
              }}
            >
              Please select a valid date range, 14 days or less!
            </p>
          </Optional>
          <Optional show={showCustomDateField && !dateFilter}>
            <p
              className="p-text-error p-mt-0"
              style={{ textAlign: "left", fontSize: "0.75rem" }}
            >
              Note: You can only retrieve metrics within 14 day intervals.
            </p>
          </Optional>
          <Optional show={showCustomDateField}>
            <div style={{ textAlign: "right" }}>
              <button
                className="primary-button"
                style={{ width: "10rem" }}
                onClick={handleCustomDateSearch}
              >
                Search
              </button>
            </div>
          </Optional>
        </div>
      </div>

      <Optional show={dateRangeValue !== "today"}>
        <div>
          <p
            className="p-text-left"
            style={{ fontSize: "0.8rem", fontStyle: "italic" }}
          >
            Showing results from{" "}
            <span>
              {" "}
              {moment(dateFilter?.current?.startDate).format(
                "MMMM Do YYYY"
              )}{" "}
            </span>
            -{" "}
            <span>
              {moment(dateFilter?.current?.endDate).format("MMMM Do YYYY")}{" "}
            </span>
          </p>
        </div>
      </Optional>

      <MetricsSummaryCards
        overallMetrics={overallMetrics}
        userType={props.userType}
        currentIndex={currentIndex}
        selectedDateRange={selectedDateRange?.current}
        currentTime={currentTime}
        disputeMetricsBreakdown={disputeMetricsBreakdown}
        loading={loading}
        selectedReport={selectedReport?.current}
        reload={reload}
      />
      <Optional show={loading}>
        <div className="card p-mt-4">
          <Skeleton />
          <Skeleton className="p-mt-3" />
          <Skeleton className="p-mt-3" />
          <Skeleton className="p-mt-3" />
          <Skeleton className="p-mt-3" />
          <Skeleton className="p-mt-3" />
          <Skeleton className="p-mt-3" />
        </div>
      </Optional>
      <Optional show={!loading}>{currentChartView()}</Optional>
    </div>
  );
}
